import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=8f3682e6&lang=pug&"
import script from "./PriceField.vue?vue&type=script&lang=js&"
export * from "./PriceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports